// Press + Featured Reviews Carousels
Object.assign(window.HiSnaps, {

    // -------------------------------------------------------------------------
    // Press Carousel

    press: {
        async init() {
            const group = $1('.quote-group[data-carousel="press"]');
            if (!group) return;

            const loader = document.createElement('div');
            loader.className = 'loader';
            group.classList.add('loading');
            group.appendChild(loader);

            try {
                const { reviews } = await HiSnaps.reviewsApi.get('/reviews', {
                    type: 'press',
                    sort: 'newest',
                    per_page: 20,
                });
                group.classList.remove('loading');
                loader.remove();
                if (!reviews?.length) return;
                this.render(group, reviews);
                HiSnaps.carousels.initCarousel(group);
            } catch (e) {
                group.classList.remove('loading');
                loader.remove();
                console.error('[HiSnaps] Press carousel error:', e);
            }
        },

        render(group, items) {
            const insertBefore = group.querySelector('.carousel-controls');
            items.forEach((item, i) => {
                group.insertBefore(this.buildQuote(item, i === 0), insertBefore);
            });
        },

        buildQuote(item, isCurrent) {
            const quote = document.createElement('div');
            quote.className = 'quote stack align-items:center';
            if (isCurrent) quote.classList.add('current');

            const h3 = document.createElement('h3');
            const q = document.createElement('q');
            q.textContent = item.pull_quote || item.body;
            h3.appendChild(q);

            const cite = document.createElement('cite');
            if (item.press_logo_url) {
                const img = document.createElement('img');
                img.src = item.press_logo_url;
                img.alt = item.author_name || '';
                img.className = 'press-logo';
                cite.appendChild(img);
            } else {
                cite.textContent = item.author_name || '';
            }

            quote.appendChild(h3);
            quote.appendChild(cite);
            return quote;
        },

    },


    // -------------------------------------------------------------------------
    // Featured Reviews Carousel

    featuredReviews: {
        async init() {
            const group = $1('.quote-group[data-carousel="reviews"]');
            if (!group) return;

            const loader = document.createElement('div');
            loader.className = 'loader';
            group.classList.add('loading');
            group.appendChild(loader);

            try {
                const { reviews } = await HiSnaps.reviewsApi.get('/reviews', {
                    type: 'review',
                    collection: 'Homepage',
                    sort: 'newest',
                    per_page: 20,
                });
                group.classList.remove('loading');
                loader.remove();
                if (!reviews?.length) return;
                this.render(group, reviews);
                HiSnaps.carousels.initCarousel(group);
            } catch (e) {
                group.classList.remove('loading');
                loader.remove();
                console.error('[HiSnaps] Featured reviews carousel error:', e);
            }
        },

        render(group, items) {
            const insertBefore = group.querySelector('.carousel-controls');
            items.forEach((item, i) => {
                group.insertBefore(this.buildQuote(item, i === 0), insertBefore);
            });
        },

        buildQuote(item, isCurrent) {
            const quote = document.createElement('div');
            quote.className = 'quote stack align-items:center';
            if (isCurrent) quote.classList.add('current');

            const h3 = document.createElement('h3');
            const q = document.createElement('q');
            q.textContent = item.pull_quote || item.body;
            h3.appendChild(q);

            const cite = document.createElement('cite');
            cite.appendChild(document.createTextNode(item.author_name || ''));
            if (item.is_verified_buyer) {
                const em = document.createElement('em');
                em.textContent = 'Verified Buyer';
                cite.appendChild(em);
            }

            quote.appendChild(h3);
            quote.appendChild(cite);
            return quote;
        },

    },


    // -------------------------------------------------------------------------
    // Auto-Rotate

    autoRotate: {
        pressGroup:            null,
        reviewsGroup:          null,
        interval:              null,
        userPauseTimer:        null,
        pressFullyVisible:     false,
        reviewsPartlyVisible:  false,
        pressAnyVisible:       false,
        reviewsAnyVisible:     false,

        init() {
            this.pressGroup   = $1('.quote-group[data-carousel="press"]');
            this.reviewsGroup = $1('.quote-group[data-carousel="reviews"]');
            if (!this.pressGroup || !this.reviewsGroup) return;
            this.setupObservers();
            this.setupUserPause();
        },

        setupObservers() {
            const check = () => this.onVisibilityChange();

            // Press must be fully in view to start.
            new IntersectionObserver((entries) => {
                entries.forEach(e => {
                    this.pressFullyVisible = e.intersectionRatio >= 1.0;
                    this.pressAnyVisible   = e.isIntersecting;
                });
                check();
            }, { threshold: [0, 1.0] }).observe(this.pressGroup);

            // Reviews needs at least 15% visible to start.
            new IntersectionObserver((entries) => {
                entries.forEach(e => {
                    this.reviewsPartlyVisible = e.intersectionRatio >= 0.15;
                    this.reviewsAnyVisible    = e.isIntersecting;
                });
                check();
            }, { threshold: [0, 0.15] }).observe(this.reviewsGroup);
        },

        setupUserPause() {
            [this.pressGroup, this.reviewsGroup].forEach(group => {
                group.querySelectorAll('.carousel-prev, .carousel-next').forEach(btn => {
                    btn.addEventListener('click', () => this.onUserInteraction());
                });
            });
        },

        canStart() { return this.pressFullyVisible && this.reviewsPartlyVisible; },

        onVisibilityChange() {
            if (!this.pressAnyVisible) {
                if (this.userPauseTimer) {
                    clearTimeout(this.userPauseTimer);
                    this.userPauseTimer = null;
                }
                this.stop();
            } else if (!this.interval && !this.userPauseTimer && this.canStart()) {
                this.start();
            }
        },

        onUserInteraction() {
            if (this.userPauseTimer) clearTimeout(this.userPauseTimer);
            this.stop();
            this.userPauseTimer = setTimeout(() => {
                this.userPauseTimer = null;
                if (this.canStart()) this.start();
            }, 12000);
        },

        start() {
            if (this.interval) return;
            this.interval = setInterval(() => this.advance(), 5000);
        },

        stop() {
            clearInterval(this.interval);
            this.interval = null;
        },

        advance() {
            this.pressGroup._next?.();
            setTimeout(() => this.reviewsGroup._next?.(), 500);
        },
    },

});
